export class LeadType {
    LeadTypeID: number;
    LeadTypeName: string;
    LeadTypeDescription: string;
    IsActive: boolean = true;
    ModifiedBy: number;
}